import { VStack, Link, Text } from "@chakra-ui/react";

const Menu = () => {
  return (
    <VStack align="start" spacing={4} py={4} px={8}>
      <Text fontWeight="bold" color={"gray.400"}>Tools</Text>
      <Link href="/base64encode">Base64 Encoder</Link>
      <Link href="/base64decode">Base64 Decoder</Link>
      <Link href="/json-formatter">JSON Formatter</Link>
      <Link href="/word-counter">Word Counter</Link>
      <Link href="/password-generator">Password Generator</Link>
      <Link href="/image-generator">Dummy Image Generator</Link>
    </VStack>
  )
};

export default Menu;